module.exports = __webpack_public_path__ + "static/media/STAF_nynorsk med tjenesteløfte_primærlogo_neg(hvit).26a1e6d9.png";